import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemContent,
  ColorPaletteProp,
  ListDivider,
  Sheet,
  Table,
  iconButtonClasses,
  Button,
  IconButton,
  Card,
  Input,
  ButtonGroup,
  Dropdown,
  MenuButton,
  Menu,
  MenuItem,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle } from "../../../components";

import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import {
  getPartnerAgentsRequest,
  getPartnerAgentsReset,
} from "../../../store/actions";

import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import {
  CalendarMonthOutlined,
  FilterAltOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
  WarningRounded,
} from "@mui/icons-material";
import { STATUS } from "../../../constant";
import { NAVIGATE_TO_AGENTVIEWPAGE } from "../../../route/types";
import { StatusBadge } from "../../../components";

const MobileViewTable = ({ data, props }) => {
  return (
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      {data.map((listItem, index) => (
        <List
          key={index}
          size="sm"
          sx={{
            "--ListItem-paddingX": 0,
          }}
        >
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <ListItemContent
              sx={{ display: "flex", gap: 2, alignItems: "start" }}
            >
              <div>
                <Typography fontWeight={600} gutterBottom>
                  {listItem.name}
                </Typography>

                <Dropdown>
                  <MenuButton variant="plain" size="sm">
                    More ...
                  </MenuButton>
                  <Menu placement="bottom-end" sx={{ p: 1 }}>
                    <Typography level="body-sm" gutterBottom>
                      <b>Account Code:</b> {listItem.account_code}
                    </Typography>
                    <Typography level="body-sm" gutterBottom>
                      <b>Bank Account Number: </b>
                      {listItem.ref_bank_number}
                    </Typography>
                  </Menu>
                </Dropdown>
              </div>
            </ListItemContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                rowGap: 1,
              }}
            >
              <StatusBadge
                color={
                  {
                    1: "success",
                    2: "warning",
                    3: "neutral",
                    4: "danger",
                  }[listItem.status] as ColorPaletteProp
                }
              >
                {
                  {
                    1: "Active",
                    2: "Inactive",
                    3: "Pending",
                    4: "Rejected",
                  }[listItem.status]
                }
              </StatusBadge>
              <ButtonGroup variant="soft" size="sm">
                <Button color="primary" onClick={() => props.view(listItem)}>
                  <RemoveRedEyeOutlined />
                </Button>
              </ButtonGroup>
            </Box>
          </ListItem>
          <ListDivider />
        </List>
      ))}
    </Box>
  );
};

const DesktopViewTable = ({ data, props }) => {
  return (
    <React.Fragment>
      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          display: { xs: "none", md: "flex", lg: "flex" },
          // width: '100%',
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground":
              "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground":
              "var(--joy-palette-background-level1)",
            "--TableCell-paddingY": "4px",
            "--TableCell-paddingX": "8px",
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,
              bgcolor: "var(--TableCell-headBackground)",
            },
          }}
        >
          <thead>
            <tr style={{ textAlign: "center" }}>
              <th style={{ width: 100, padding: "10px 6px" }}>Name</th>
              <th style={{ width: 100, padding: "10px 6px" }}>Account Code</th>
              <th style={{ width: 100, padding: "10px 6px" }}>
                Bank Account Number
              </th>
              <th style={{ width: 50, padding: "10px 6px" }}>Status</th>
              <th aria-label="last" style={{ width: 100, padding: "10px 6px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>
                  <Typography level="body-sm">{row.name}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.account_code}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.ref_bank_number}</Typography>
                </td>
                <td>
                  <StatusBadge
                    color={
                      {
                        1: "success",
                        2: "warning",
                        3: "neutral",
                        4: "danger",
                      }[row.status] as ColorPaletteProp
                    }
                  >
                    {
                      {
                        1: "Active",
                        2: "Inactive",
                        3: "Pending",
                        4: "Rejected",
                      }[row.status]
                    }
                  </StatusBadge>
                </td>
                <td>
                  <ButtonGroup variant="soft" size="sm">
                    <Button
                      title="View"
                      color="primary"
                      onClick={() => props.view(row)}
                    >
                      <RemoveRedEyeOutlined />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </React.Fragment>
  );
};

const PartnerAgents = ({
  loginResult,

  getPartnerAgentsStatus,
  getPartnerAgentsResult,
  getPartnerAgentsErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width:600px)");
  const { state } = useLocation();
  const { partner_id } = state;

  const [agentData, setAgentData] = useState([]);

  useEffect(() => {
    if (getPartnerAgentsStatus === STATUS.SUCCESS) {
      setAgentData(getPartnerAgentsResult);
    } else if (getPartnerAgentsStatus === STATUS.ERROR) {
      setAgentData([]);
      toast.error(getPartnerAgentsErrorMessage);
      dispatch(getPartnerAgentsReset());
    }
  }, [
    dispatch,
    getPartnerAgentsErrorMessage,
    getPartnerAgentsStatus,
    getPartnerAgentsResult,
  ]);

  useEffect(() => {
    const data = {
      partner_id: partner_id,
    };
    dispatch(getPartnerAgentsRequest(loginResult.token, data));
  }, [dispatch, loginResult, partner_id]);

  /* -------- FUNCTION TO SEARCH ------ */
  const [search, setSearch] = useState("");
  const [filterBy, setFilterBy] = useState("name");

  // filtre by  name
  const filteredData = agentData.filter((item) => {
    if (filterBy === "name") {
      return item.name.toLowerCase().includes(search.toLowerCase());
    } else if (filterBy === "created date") {
      return item.created_at.includes(search);
    } else {
      return item.name.toLowerCase().includes(search.toLowerCase());
    }
  });

  /* ------ pagination functions ------- */
  const [currentPage, setCurrentPage] = useState(0);
  const ITEMS_PER_PAGE = 20;
  const pageLength = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(0, prevPage - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageLength - 1));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE,
  );
  /* ---- end of pagination functions ------- */

  const goToViewPage = (details) => {
    navigate(NAVIGATE_TO_AGENTVIEWPAGE, {
      state: {
        agent_id: details.id,
      },
    });
  };

  const checkLoading = () => {
    if (getPartnerAgentsStatus === STATUS.LOADING) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box>
      <PageTitle title={"Manage Agents"} />

      <LoadingView loading={checkLoading()} />

      {/* search */}
      <Sheet
        className="SearchAndFilters"
        sx={{
          display: "flex",
          my: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          // width: { xs: 'auto', md: '30%' },
          justifyContent: "space-between",
        }}
      >
        {agentData.length > 0 && (
          <Input
            size="sm"
            placeholder={`Search by ${filterBy}`}
            type={
              { date: "date", name: "text", address: "text", mobile: "number" }[
                filterBy
              ]
            }
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            startDecorator={
              filterBy === "date" ? <CalendarMonthOutlined /> : <SearchIcon />
            }
            endDecorator={
              <Dropdown>
                <MenuButton variant="plain">
                  {/* <Typography level="body-sm">Filter</Typography> */}
                  <FilterAltOutlined />
                </MenuButton>
                <Menu sx={{ minWidth: "120px", fontSize: "14px" }}>
                  <MenuItem
                    onClick={() => setFilterBy("name")}
                    selected={filterBy === "name"}
                  >
                    Name
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("date")}
                    selected={filterBy === "date"}
                  >
                    Created at
                  </MenuItem>
                </Menu>
              </Dropdown>
            }
            sx={{
              width: { xs: "auto", md: "30%" },
              textTransform: "capitalize",
            }}
          />
        )}
      </Sheet>

      {agentData.length > 0 ? (
        <>
          {/* ------ render different view depend on plafform -------- */}
          <MobileViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />
          <DesktopViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />

          {/* Pagination */}
          {agentData.length > ITEMS_PER_PAGE && (
            <Box
              className="Pagination-laptopUp"
              sx={{
                pt: 2,
                gap: 1,
                [`& .${iconButtonClasses.root}`]: { borderRadius: "50%" },
                display: "flex",
              }}
            >
              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                startDecorator={<KeyboardArrowLeftIcon />}
                onClick={handlePreviousPage}
                disabled={currentPage === 0}
              >
                {isDesktop ? "Previous" : ""}
              </Button>

              <Box sx={{ flex: 1 }} />
              {/* for desktop to display page number */}
              {Array.from({ length: pageLength }).map((_, page) => (
                <IconButton
                  key={page}
                  size="sm"
                  variant={"outlined"}
                  color="neutral"
                  onClick={() => handlePageChange(page)}
                  disabled={currentPage === page}
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  {page + 1}
                </IconButton>
              ))}

              {/* for mobile to display page number */}
              <Typography
                level="body-sm"
                mx="auto"
                textAlign={"center"}
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                Page {currentPage + 1} of {pageLength}
              </Typography>
              <Box sx={{ flex: 1 }} />

              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                endDecorator={<KeyboardArrowRightIcon />}
                onClick={handleNextPage}
                disabled={currentPage === pageLength - 1}
              >
                {isDesktop ? "Next" : ""}
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            top: "20%",
          }}
        >
          <WarningRounded
            sx={{ fontSize: "50px", color: "background.appcolor" }}
          />
          <Typography level="title-md">Resource not Found</Typography>
          <Typography level="body-sm" textAlign={"center"}>
            This can be either no Agent list available or network issue.
          </Typography>
          <Button
            onClick={() =>
              dispatch(
                getPartnerAgentsRequest(loginResult.token, {
                  partner_id: partner_id,
                }),
              )
            }
            startDecorator={<RefreshOutlined />}
          >
            REFRESH
          </Button>
        </Card>
      )}
    </Box>
  );
};

const mapStateToProps = ({ auth, partner }) => {
  const { otpResult: loginResult } = auth;
  const {
    getPartnerAgentsStatus,
    getPartnerAgentsResult,
    getPartnerAgentsErrorMessage,
  } = partner;

  return {
    loginResult,

    getPartnerAgentsStatus,
    getPartnerAgentsResult,
    getPartnerAgentsErrorMessage,
  };
};

export default connect(mapStateToProps, {})(PartnerAgents);
